var acom_app = acom_app || {};

(function ($) {
    var AdminAjaxSyncableMixin = {
        sync: function () {
            return $.ajax({
                url: window['acom_localize']['ajaxurl'],
                type: "POST",
                data: {
                    action: 'acom_settings',
                    nonce: window['acom_localize']['ajax_nonce'],
                    model: JSON.stringify(this.toJSON())
                },
            });
        }
    };

    acom_app.BaseModel = Backbone.Model.extend(_.defaults({}, AdminAjaxSyncableMixin));

    acom_app.BaseNestedModel = Backbone.DeepModel.extend(_.defaults({}, AdminAjaxSyncableMixin));

    acom_app.BaseCollection = Backbone.Collection.extend(_.defaults({}, AdminAjaxSyncableMixin));
})(jQuery);